import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { TextInput, Text, Services, FormModal, Loader, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';

import * as session from '../../services/session';
import { changeUserPassword } from '../../actions/user';

class ChangePassword extends Component {
    state = {
        existingPassword: '',
        newPassword: '',
        confirmPassword: '',
        passwordError: false,
        confirmPasswordError: false,
        notifyText: false,
        notifyTextColor: '',
        visibility: false
    };

    _toggleVisibility = () => {
        this.setState({
            visibility: !this.state.visibility
        });
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type], i18n.locale)
        });
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value.trim()
        });
    };

    _confirm = async () => {
        const newPasswordError = await Services.validateInput('password', this.state.newPassword);
        const confirmPasswordError = await Services.validateInput('password', this.state.confirmPassword);

        this.setState({
            newPasswordError,
            confirmPasswordError
        });

        if (newPasswordError || confirmPasswordError) {
            return false;
        }

        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({
                notifyText: i18n.t(tokens.labels.signup.pleaseConfirmThatYourPasswordsMatch),
                notifyTextColor: 'red'
            });

            return false;
        }

        const success = await this.props.dispatch(changeUserPassword(this.state.existingPassword, this.state.newPassword));

        if (success) {
            this.setState({
                notifyText: false
            });

            if (this.props.isForgotPassword) {
                session.removePasswordWasReset();
            }

            this.props.close();
        }

        return true;
    };

    render() {
        const { isForgotPassword, whitelabel } = this.props;

        return (
            <FormModal
                testid="change-password-modal"
                open={true}
                close={this.props.close}
                title={isForgotPassword ? i18n.t(tokens.titles.updatePasswordAfterReset) : i18n.t(tokens.titles.changePassword) }
                disableBackdropClick
                disableEscapeKeyDown
                onSave={this._confirm}
                customContainerStyle={{ width: 500 }}
            >
                {
                    this.state.notifyText &&
                        <Text
                            align="center"
                            color={this.state.notifyTextColor}
                            small
                            display="inline-block"
                        >
                            {this.state.notifyText}
                        </Text>
                }

                <TextInput
                    label={isForgotPassword ? i18n.t(tokens.labels.changePassword.passwordSentInEmail) : i18n.t(tokens.labels.changePassword.existingPassword) }
                    value={this.state.existingPassword}
                    inputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {
                                    this.state.visibility ?
                                        <VisibilityIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                        :
                                        <VisibilityOffIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                }
                            </InputAdornment>
                        )
                    }}
                    onBlur={() => this._onBlur('existingPassword')}
                    onChange={(value) => this._handleInputChange('existingPassword', value)}
                    error={Boolean(this.state.existingPasswordError)}
                    helperText={this.state.existingPasswordError}
                    autoComplete="new-password"
                    secure={!this.state.visibility}
                    fullWidth
                    autofocus
                />

                <TextInput
                    label={ i18n.t(tokens.labels.changePassword.newPassword) }
                    value={this.state.newPassword}
                    inputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {
                                    this.state.visibility ?
                                        <VisibilityIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                        :
                                        <VisibilityOffIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                }
                            </InputAdornment>
                        )
                    }}
                    onBlur={() => this._onBlur('newPassword')}
                    onChange={(value) => this._handleInputChange('newPassword', value)}
                    error={Boolean(this.state.newPasswordError)}
                    helperText={this.state.newPasswordError}
                    secure={!this.state.visibility}
                    autoComplete="new-password"
                    fullWidth
                />

                <TextInput
                    label={ i18n.t(tokens.labels.changePassword.confirmPassword) }
                    value={this.state.confirmPassword}
                    inputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {
                                    this.state.visibility ?
                                        <VisibilityIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                        :
                                        <VisibilityOffIcon
                                            style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                            onClick={this._toggleVisibility}
                                        />
                                }
                            </InputAdornment>
                        )
                    }}
                    onBlur={() => this._onBlur('confirmPassword')}
                    onChange={(value) => this._handleInputChange('confirmPassword', value)}
                    error={Boolean(this.state.confirmPasswordError)}
                    helperText={this.state.confirmPasswordError}
                    secure={!this.state.visibility}
                    autoComplete="new-password"
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                    fullWidth
                />

                {this.props.loading && <Loader whitelabel={ whitelabel } customImageStyle={{ top: '50%' }} />}
            </FormModal>
        );
    }
}

ChangePassword.propTypes = {
    loading: PropTypes.bool,
    meta: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    meta: state.user.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(ChangePassword);